import axios from 'axios';

const SYNC_CART_URL = 'https://app.rullier.ova-consulting.fr/rest/V1/puc/quote/sync';

/**
 * Envoie les produits du devis vers le panier e-commerce (Magento).
 * @param {Array<{sku: string, qty: number}>} items - Liste des produits avec SKU et quantité (qty)
 * @returns {Promise<{success: boolean, masked_quote_id?: string, redirect_url?: string, items_added?: number, errors?: string[]}>}
 */
export const syncQuoteToEcommerceCart = async (items) => {
  const payload = {
    items: (items || []).map((item) => ({
      sku: String(item.sku || '').trim(),
      qty: Math.max(0, parseInt(item.qty ?? item.quantity, 10) || 0)
    })).filter((item) => item.sku && item.qty > 0)
  };

  const response = await axios.post(SYNC_CART_URL, payload, {
    headers: {
      'Content-Type': 'application/json'
    },
    timeout: 60000
  });

  // Magento peut renvoyer du JSON déjà parsé, une chaîne, ou un objet imbriqué
  let data = response.data;
  if (typeof data === 'string') {
    try {
      data = JSON.parse(data);
    } catch {
      data = {};
    }
  }
  data = data || {};
  // Réponse parfois dans data.data ou data.result
  if (data.data && typeof data.data === 'object') data = data.data;
  if (data.result && typeof data.result === 'object') data = data.result;

  const masked_quote_id = data.masked_quote_id ?? null;
  const redirect_url = data.redirect_url ?? null;
  const items_added = data.items_added ?? 0;
  const errors = Array.isArray(data.errors) ? data.errors : (data.errors ? [data.errors] : []);

  // Succès si success === true OU si 200 avec redirect_url/masked_quote_id (réponse Magento typique)
  const success =
    data.success === true ||
    (response.status === 200 && (redirect_url || masked_quote_id !== null));

  console.log('[quoteSync] response:', { status: response.status, data, success, redirect_url });

  return {
    success: Boolean(success),
    masked_quote_id,
    redirect_url,
    items_added,
    errors
  };
};
